import { store } from '@/store'
import { BlipMessage } from '../models'

export class MessageReceiver {
  filter(message: BlipMessage) {
    // Redirect Messages should be ignored
    if (message.type === 'application/vnd.lime.redirect+json') {
      return false
    }
    // Ticket Messages should be ignored
    if (message.type === 'application/vnd.iris.ticket+json') {
      return false
    }

    // check if messages comes from current chatbot or, if is an echo, it was
    // send from this user to the current chatbot
    const idFrom = message.from ? message.from.split('@')[0] : undefined
    const idTo = message.to ? message.to.split('@')[0] : undefined

    if (idFrom && idTo) {
      return (
        idFrom.toLocaleLowerCase() === store.getters.botIdentity.toLocaleLowerCase() ||
        (message.metadata['#message.echo'] &&
         idTo.toLocaleLowerCase() === store.getters.botIdentity.toLocaleLowerCase() &&
         idFrom.toLocaleLowerCase() === store.getters.userIdentity.toLocaleLowerCase() &&
        (message.type !== 'application/vnd.lime.chatstate+json' ||
         message.type === 'application/vnd.lime.chatstate+json' &&
        (message.content.state !== 'composing' && message.content.state !== 'paused')))
      )
    } else {
      return false
    }
  }

  process(message) {
    let filteredMsg = message
    if (
      message.metadata['#blip.payload.content'] ||
      message.metadata['#blip.payload.text']
    ) {
      filteredMsg = {
        ...message,
        type: message.metadata['#blip.payload.type'] || 'text/plain',
        content:
          message.metadata['#blip.payload.content'] ||
          message.metadata['#blip.payload.text'],
      }

      if (filteredMsg && filteredMsg.type !== 'text/plain') {
        try {
          filteredMsg.content = JSON.parse(filteredMsg.content)
        } catch (e) {}
      }
    }

    return {
      ...filteredMsg,
      date: new Date(parseInt(message.metadata.date_created, 10)),
      direction: message.metadata['#message.echo'] ? 'sent' : 'received',
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/MessageReceiver.ts